export default __webpack_public_path__ + "static/media/information--food--g1.c3a95157.png";